import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { ContactForm } from "@/components/site/ContactForm";

export function QuoteDialog({ product, onClose }) {
  const label = product ? `${product.name} (${product.model})` : "";
  return (
    <Dialog open={!!product} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="quote-dialog" className="max-w-2xl rounded-none border border-white/10 bg-[#121215] p-6 md:p-10 text-white max-h-[92vh] overflow-y-auto" data-lenis-prevent>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-rescue">Quote Request</p>
        <DialogTitle className="font-display text-4xl md:text-5xl font-black uppercase leading-none">{product?.name}</DialogTitle>
        <DialogDescription className="font-mono text-xs uppercase tracking-widest text-zinc-400">{product?.model} / Department pricing on request</DialogDescription>
        <div className="mt-4">
          <ContactForm idPrefix="quote" defaultKind="quote" defaultProduct={label} onDone={onClose} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
